/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Lines_LabelInputs */



/**
* | output |
* | --- |
* | "Lines" |
*
* @param {Editor_Filter_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_lines_label = /** @type {((inputs?: Editor_Filter_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lignes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Righe")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Líneas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पंक्तियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linhas")
	return /** @type {LocalizedString} */ ("Lines")
});